import { z } from 'zod';

/** The make/model catalogue the truck form picks from; an admin extends it from the form (gitaumoses4/chukua#419). */
const catalogueNameSchema = z.string().trim().min(1).max(60);

/** Two spellings of one make or model ("Isuzu", " isuzu ", "ISUZU  ") share a key; the API stores it and the form matches typed text with it. */
export function catalogueNameKey(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

export const addTruckMakeSchema = z.object({ name: catalogueNameSchema });
export type AddTruckMakeInput = z.infer<typeof addTruckMakeSchema>;

export const addTruckModelSchema = z.object({ name: catalogueNameSchema });
export type AddTruckModelInput = z.infer<typeof addTruckModelSchema>;

export interface TruckModelView {
  id: string;
  name: string;
}

export interface TruckMakeView {
  id: string;
  name: string;
  models: TruckModelView[];
}
